// NOTE: This file was automatically generated by a script. Do not modify this file manually.
// To regenerate this file, please use `pnpm scripts:microbootstrap-generator ats`
// The command will generate files in the 'frontend/artifacts' folder with the list of files using collections
import { PropsWithChildren } from 'react'

import {
  CollectionBootstrapConfig,
  CollectionsBootstrap as CoreCollectionsBootstrap,
} from 'modules/core/components/CollectionsBootstrap'

import atsCompanies from 'modules/ats/store/collections/atsCompanies'
import companies from 'modules/core/store/collections/companies'
import features from 'modules/core/store/collections/features'
import locations from 'modules/locations/store/collections/locations'

const CollectionsBootstrap = ({ children }: PropsWithChildren) => {
  /* atsCompanies manually fetched by 5 pages in this module */
  const collections: CollectionBootstrapConfig[] = [
    [atsCompanies, {}] /* Referenced by 2 cases in this module */,
    [companies, {}] /* Referenced by 16 cases in this module */,
    [features, {}] /* Referenced by 23 cases in this module */,
    [locations, {}] /* Referenced by 7 cases in this module */,
  ] /* Generated file 👉 artifacts/ats-module-index.tsx-collection-dependencies-report-v2.json */

  return <CoreCollectionsBootstrap collections={collections}>{children}</CoreCollectionsBootstrap>
}

export default CollectionsBootstrap
